import React from 'react';
import {ConfigProvider as AntConfigProvider} from 'antd';
import {ConfigProviderProps} from 'antd/lib/config-provider';

interface ConfigContextProps extends ConfigProviderProps {
    topOffset: number;
    containerWidth: number;
}

const ConfigContextDefault: ConfigContextProps = {
    topOffset: 0,
    containerWidth: 1400,
};

export const ConfigContext = React.createContext(ConfigContextDefault);

const ConfigProvider: React.FC<ConfigContextProps> = ({
    children,
    topOffset,
    containerWidth,
    ...antConfig
}) => {
    const appOptions = {topOffset, containerWidth};

    return (
        <ConfigContext.Provider
            value={{...ConfigContextDefault, ...appOptions}}>
            <AntConfigProvider {...antConfig}>{children}</AntConfigProvider>
        </ConfigContext.Provider>
    );
};

export default ConfigProvider;
